import moment from 'moment'

export default {
  methods: {
    dateFormat(value, format = 'Y.MM.DD') {
      return moment(value).format(format)
    },
    videoTimeFormat(seconds) {
      if (!seconds) {
        return '-:--'
      }
      const min = Math.floor(seconds / 60)
      const sec = ('00' + (seconds % 60)).slice(-2)
      return `${min}:${sec}`
    },
    numberToCurrency(number) {
      return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円'
    },
    numberFormat(number) {
      return String(number).replace(/(\d)(?=(\d\d\d)+$)/g, '$1,')
    },
  },
}
